/**
 * TeddyWishlist.checkCustomer() fa merge() tra localStorage e window.theme.wishlist (metafield
 * al page load). Il merge è un'unione: varianti ancora sullo snapshot server ma già rimosse
 * in locale vengono re-inserite (es. dopo remove + save async o ricarica con metafield non aggiornato).
 *
 * Allineiamo theme.wishlist al locale dopo ogni modifica e, se c'è contenuto locale,
 * non usiamo merge: la lista locale ha priorità e viene persistita con save().
 */
(function () {
	function normHandle(h) {
		return String(h == null ? '' : h)
			.trim()
			.toLowerCase();
	}

	function sameWishlistItem(a, b) {
		return (
			a &&
			b &&
			String(a.variant) === String(b.variant) &&
			normHandle(a.handle) === normHandle(b.handle)
		);
	}

	/**
	 * Confronti stabili variant/handle (numero vs stringa da JSON/dataset) senza wrappare getItems().
	 */
	function patchWishlistItemEquality() {
		if (!window.TeddyWishlist) return false;
		if (TeddyWishlist.__calliopeItemEq) return true;

		TeddyWishlist.isInWishlist = function (item) {
			if (item == null) return false;
			var items = TeddyWishlist.getItems();
			for (var i = 0; i < items.length; i++) {
				if (sameWishlistItem(items[i], item)) return true;
			}
			return false;
		};

		TeddyWishlist.removeItem = function (item) {
			if (item == null || item === undefined) {
				console.error('TeddyWishlist: removeItem - item is undefined or null');
				return;
			}
			if (!TeddyWishlist.isInWishlist(item)) {
				console.error('TeddyWishlist: removeItem - item is not in wishlist');
				return;
			}
			var wishlist = TeddyWishlist.getItems();
			var index = -1;
			for (var j = 0; j < wishlist.length; j++) {
				if (sameWishlistItem(wishlist[j], item)) {
					index = j;
					break;
				}
			}
			if (index === -1) return;
			wishlist.splice(index, 1);
			localStorage.setItem('wishlist', JSON.stringify(wishlist));
			window.dispatchEvent(new CustomEvent('mc:wishlist:removed', { detail: item }));
			window.dispatchEvent(new CustomEvent('mc:wishlist:changed', { detail: TeddyWishlist.getItems() }));
			if (typeof TeddyWishlist.save === 'function') {
				TeddyWishlist.save();
			}
		};

		TeddyWishlist.__calliopeItemEq = true;
		return true;
	}

	function mirrorThemeWishlistFromLocal() {
		if (!window.TeddyWishlist || !window.theme || window.theme.wishlist === undefined) return;
		try {
			window.theme.wishlist = JSON.parse(JSON.stringify(TeddyWishlist.getItems()));
		} catch (e) {
			/* ignore */
		}
	}

	/**
	 * Dopo addItem il bottone a volte resta "vuoto" (setState prima che tutto sia allineato).
	 * Ricalcoliamo tutti i teddy-wishlist-btn dopo un tick + frame.
	 */
	function scheduleRefreshAllWishlistButtons() {
		if (!window.TeddyWishlist) return;
		var run = function () {
			document.querySelectorAll('teddy-wishlist-btn').forEach(function (btn) {
				try {
					if (typeof btn.setState === 'function') btn.setState();
				} catch (e) {
					/* ignore */
				}
			});
		};
		setTimeout(run, 0);
		if (typeof requestAnimationFrame === 'function') {
			requestAnimationFrame(function () {
				setTimeout(run, 0);
			});
		}
	}

	function patchAddItemRefresh() {
		if (!window.TeddyWishlist || typeof TeddyWishlist.addItem !== 'function') return false;
		if (TeddyWishlist.__calliopeAddRefresh) return true;
		var orig = TeddyWishlist.addItem.bind(TeddyWishlist);
		TeddyWishlist.addItem = function (item) {
			orig(item);
			scheduleRefreshAllWishlistButtons();
		};
		TeddyWishlist.__calliopeAddRefresh = true;
		return true;
	}

	function patchCheckCustomer() {
		if (!window.TeddyWishlist || typeof TeddyWishlist.checkCustomer !== 'function') return false;
		if (TeddyWishlist.checkCustomer.__calliopePatched) return true;

		TeddyWishlist.checkCustomer = function () {
			if (window.theme === undefined || window.theme.wishlist === undefined) return;
			if (TeddyWishlist.isSameWishlist(window.theme.wishlist)) return;

			var local = TeddyWishlist.getItems();
			var server = window.theme.wishlist;

			if ((!local || local.length === 0) && Array.isArray(server) && server.length > 0) {
				TeddyWishlist.merge(server);
				mirrorThemeWishlistFromLocal();
				return;
			}

			window.theme.wishlist = JSON.parse(JSON.stringify(local));
			TeddyWishlist.save();
		};
		TeddyWishlist.checkCustomer.__calliopePatched = true;
		return true;
	}

	function init() {
		if (!patchWishlistItemEquality()) {
			requestAnimationFrame(init);
			return;
		}
		if (!patchAddItemRefresh()) {
			requestAnimationFrame(init);
			return;
		}
		if (!patchCheckCustomer()) {
			requestAnimationFrame(init);
			return;
		}
		['mc:wishlist:changed', 'mc:wishlist:saved', 'mc:wishlist:cleared'].forEach(function (ev) {
			window.addEventListener(ev, mirrorThemeWishlistFromLocal);
		});
	}

	init();
})();
